import React, { Component } from 'react';
/*import PreLoader from '../common/PreLoader';
import HeaderBar from '../common/HeaderBar';
import GraphicsLayout from "./GraphicsLayout";
import GraphicModal from "./GraphicModal";*/
import * as galleryReducers from "../../reducers/gallery";
import {withRouter} from "react-router";
import connect from "react-redux/es/connect/connect";
import * as galleryActions from "../../actions/gallery";
//import FilterBar from "../common/FilterBar";
import MainLayout from "../common/MainLayout";
import {Redirect} from "react-router-dom";

class Graphics extends Component {

    constructor(props) {
        super(props);
        this.state = {
            gal_type: 'MY_UPLOADS',
            userDet : window.localStorage.userDet?JSON.parse(window.localStorage.userDet):undefined
        };
    }


    componentWillMount() {

        let data = {"type" : this.state.gal_type};
        this.props.setGalleryType(data);
    }
    render() {
        if (!this.state.userDet) {
            return <Redirect to='/'/>;
        }

        return (
            <MainLayout pageName="MY_UPLOADS" />
        );
    }
}

function mapStateToProps(state) {

    return {
        galleryUpdate  :galleryReducers.setGalleryUpdate(state)
    };

}
export default  withRouter(connect(mapStateToProps, {
    setGalleryType : galleryActions.setType
})(Graphics));



// WEBPACK FOOTER //
// ./src/components/gallery/Graphics.js